<template>
  <div id="unitDetails">

    <div class="section-content" ref="scrollArea">
    
      <template v-if="selected">
      
        <div class="vo-card">
        
          <div class="vo-header">
            Invite Details
          </div>
          <div class="vo-content">
            <div class="details">

              <div class="vo-s-list">
                <div class="name">Email Address</div>
                <div class="value">{{ selected.email }}</div>
              </div>
              
              <div class="vo-s-list">
                <div class="name">Invited Date</div>
                <div class="value">{{ selected.created | dateShorthand }}</div>
              </div>

              <div class="vo-s-list">
                <div class="name">Role</div>
                <div class="value vo-site-link">{{ selected.role.parent.title }}</div>
              </div>

              <div class="vo-s-list">
                <div class="name">Access Level</div>
  
                <div class="value vo-site-link">
                  <div v-if="!selected.role.unit && !selected.role.property">All Properties</div>
                  <div v-if="property">{{ property.name }}</div>
                  <div v-if="unit">{{ unit.title }}</div>
                </div>
              </div>

            </div>
            <div class="clear"></div>
          </div>
          <div class="vo-footer">
            <v-btn class="vo-button" flat @click="resendInviteDialog">
              <v-icon>mdi-send</v-icon>
              <span>Resend</span>
            </v-btn>
            <v-btn class="vo-button red" flat @click="deleteInviteDialog">
              <v-icon>mdi-cancel</v-icon>
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>

      </template>

      <template v-else>
        <vo-empty-state text="SELECT AN INVITE"></vo-empty-state>
      </template>
    </div>

    <vo-details-header></vo-details-header>

  </div>
</template>

<script>

  import DetailsMixin from '../mixins/detailsMixin.js';

  export default {
    mixins: [DetailsMixin],
    methods: {

      loadInvite () {
        this.selectFromDetails(this.page, 'loadInvite', {
          invite: this.$route.query.details
        });
      },

      resendInviteDialog () {
        
        Dialog.showDialog({
          title: 'Cancel Invite',
          html: 'Are you sure you want to resend this invite to <b>' + this.selected.email + '</b>?',
          confirm: {
            action: () => {

              return this.$store.dispatch('resendInvite', {
                invite: this.selected._id
              })
              .then(data => {
                Toast.show('Invite resent.', 'success');
                return Promise.resolve(true);
              })
              .catch(e => {
                return Promise.reject(e);
              });
            },
            title: 'Yes'
          },
          dismiss: {
            title: 'No'
          }
        });
      },

      deleteInviteDialog () {
        
        Dialog.showDialog({
          title: 'Cancel Invite',
          html: 'Are you sure you want to cancel this invite to <b>' + this.selected.email + '</b>?',
          confirm: {
            action: () => {

              return this.$store.dispatch('deleteInvite', {
                invite: this.selected._id
              })
              .then(data => {

                this.page.list.removeItem(this.page.selected)
                this.page.selected = false;

                this.routeRemoveQuery('details');

                Toast.show('Invite cancelled.', 'success');
                return Promise.resolve();
              })
              .catch(e => {
                return Promise.reject(e);
              });
            },
            title: 'Yes'
          },
          dismiss: {
            title: 'No'
          }
        });
      }
    
    },
    watch: {
      
      '$route.query.details' () {
        this.loadInvite();
      },

      selected () {
        this.$refs.scrollArea.scrollTop = 0;
      }

    },
    computed: {
      
      selected () {
        return this.$store.getters.invite(this.page.selected);
      },

      property () {
        return this.$store.getters.property(this.selected.role.property);
      },

      unit () {
        return this.$store.getters.unit(this.selected.role.unit);
      }
    },
    created () {
      this.loadInvite();
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #unitDetails {
    
    @include fontPrimary400();

    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
      
    .section-content {
      @include scrollContainer();
      top: 48px;

      background: $lightGreen; 
      padding: 16px;
      box-sizing: border-box;
    }
  

    .vo-card {

      .avatar {
        margin: 0 20px 0 0;
        float: left;
      }

      .details {
        float: left;
      }

      .role {
        
        position: relative;
        height: 80px;
        
        .left {
          @include fontPrimary400;
          
          position: absolute;
          left: 16px;
          top: 20px;
          right: 100px;


          .title {
            @include textEllipsis;

          }

          .access-level {
            @include textEllipsis;
            margin: 2px 0 0 0;
            color: $black54;
            font-size: 12px;
          }
        }

        .right {
          position: absolute;
          right: 8px;

          .vo-icon-button {
          
            float: left;
            margin: 14px 0;

            &.delete {
  
              i {
                color: $delete_red;
              }
            }

          }
        }

        &:not(last-of-type) {
          border-bottom: $borderBlack12;
        }

      }

    } // .details-card
  }

</style>



// WEBPACK FOOTER //
// src/components/InviteDetails.vue